/*
 * @Author: your name
 * @Date: 2020-12-07 18:01:47
 * @LastEditTime: 2020-12-10 13:07:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/chatApiList.js
 */
const chatApiList = {
    chatHttplogin: '/chat-base/login',
    addSingleMember: '/chat-base/groupUser',
    sendMsg: '/chat-base/group/message/send',
    getDefaultUser: '/after-sales-order/chat/chat-user/default', // 获取默认的群聊用户
  }
  export default chatApiList
  


// WEBPACK FOOTER //
// ./src/service/basic/chatApiList.js